import { BoxDetailTimeModalProps, BoxTimeItem } from '@/box/interface'
import { Modal } from 'antd'
import React, { useState } from 'react'
import { BoxDetailTime } from '.'

export const BoxDetailTimeModal: React.FC<BoxDetailTimeModalProps> = (
  props: BoxDetailTimeModalProps
) => {
  const { editItem, visible, onVisibleChange, onSave } = props
  const [formResult, setFormResult] = useState<boolean>(false)

  const handleSave = (item: BoxTimeItem) => {
    setFormResult(false)
    onSave?.(item)
  }

  return (
    <Modal
      destroyOnClose={true}
      maskClosable={false}
      title='更改时钟'
      width={600}
      visible={visible}
      onCancel={() => onVisibleChange?.(false)}
      onOk={() => setFormResult(true)}
    >
      <BoxDetailTime
        colSpan={24}
        formResult={formResult}
        editItem={editItem}
        onSave={handleSave}
      />
    </Modal>
  )
}
